import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  axios.post(`${API}/newsletter`, { email }).then((r) => r.data);
